<template>
    <div class="bg-white vw-100 vh-100 d-flex flex-column justify-content-center align-items-center">
        <img class="col-8 col-lg-3" :src="require('@/assets/util/images/page_not_found.png')" alt="">
        <div>
            <p>Page not found. Go to <a href="/">Dashboard</a>.</p>
        </div>
    </div>
</template>
